
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequirea579"];
var parcelRegister = parcelRequire.register;
parcelRegister("gU6ka", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;


var $c4e6c829d2f8aa8a$var$_jquery = $c4e6c829d2f8aa8a$var$_interopRequireDefault((parcelRequire("jG4hL")));
function $c4e6c829d2f8aa8a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $c4e6c829d2f8aa8a$var$$donate = (0, $c4e6c829d2f8aa8a$var$_jquery["default"])(".header-link-donate");
var $c4e6c829d2f8aa8a$var$donateSequence = function donateSequence(newClass) {
    if (window.innerWidth <= 991) return;
    $c4e6c829d2f8aa8a$var$$donate.addClass("hide");
    if (newClass === "fixed") setTimeout(function() {
        $c4e6c829d2f8aa8a$var$$donate.addClass("fixed");
        $c4e6c829d2f8aa8a$var$$donate.removeClass("hide");
    }, 350);
    else setTimeout(function() {
        $c4e6c829d2f8aa8a$var$$donate.removeClass("fixed");
        $c4e6c829d2f8aa8a$var$$donate.removeClass("hide");
    }, 350);
};
var $c4e6c829d2f8aa8a$var$init = module.exports.init = function init() {
    var body = document.querySelector("body");
    var $header = (0, $c4e6c829d2f8aa8a$var$_jquery["default"])(".header");
    var $flyoutMenu = $header.siblings(".flyout-menu");
    var $burgerBtn = $header.find(".btn--burger"); //  || $header.find('.btn--burger-2')
    var $mainNav = $header.find(".main-nav");
    var scrollStart = document.querySelector(".header") ? document.querySelector(".header").offsetHeight : 7;
    var headerHeight = document.querySelector(".header");
    var isHeaderMini = false;
    var isFlyoutHidden = true;
    var isWideScreen = window.innerWidth > 991;
    // Method to hide mobile flyout
    var hideMobileMainNav = function hideMobileMainNav() {
        $mainNav.addClass("main-nav--hidding").removeClass("show");
        setTimeout(function() {
            $mainNav.removeClass("main-nav--hidding");
        }, 500);
    };
    // check every [data-menu] in the mainNav will have a corresponding [data-category] in the flyout menu
    var checkMenuCategory = function checkMenuCategory() {
        var mainNavItems = $mainNav.find("li");
        var flyoutMenuItems = $flyoutMenu.find(".flyout-menu__category");
        mainNavItems.each(function() {
            var dataMenu = (0, $c4e6c829d2f8aa8a$var$_jquery["default"])(this).data("menu");
            var menu = flyoutMenuItems.filter('[data-category="' + dataMenu + '"]');
            if (menu.length > 0) this.classList.add("has-category");
        });
    };
    checkMenuCategory();
    /**
   * Utility method to hide flyout with CSS effect
   *
   * @param {Boolean} closeMenu - indicates that the main navigation should also be closed
   * (normally when clicked) outside of the flyout
   */ var closeFlyoutMenu = function closeFlyoutMenu(closeMenu) {
        if (isFlyoutHidden) return;
        $header.removeClass("header--opened-flyout");
        $flyoutMenu.removeClass("show").addClass("hiding");
        isFlyoutHidden = true;
        setTimeout(function() {
            $flyoutMenu.removeClass("hiding");
        }, 400);
        if (closeMenu) {
            $burgerBtn.removeClass("active");
            $mainNav.find("ul").children().removeAttr("style");
            hideMobileMainNav();
        }
    };
    /**
   * Handles click event outside of flyout menu (backdrop)
   *
   * @param {Event} e - click event
   */ var _clickOutFlyoutHandler = function clickOutFlyoutHandler(e) {
        var targetElem = (0, $c4e6c829d2f8aa8a$var$_jquery["default"])(e.target);
        if (targetElem.closest($flyoutMenu).length || targetElem.closest($mainNav).length || targetElem.closest($header).length && !$flyoutMenu.find(".flyout-menu-close").length) return;
        $mainNav.find("li").removeClass("active");
        $burgerBtn.removeClass("active");
        closeFlyoutMenu(true);
        (0, $c4e6c829d2f8aa8a$var$_jquery["default"])("body").off("click", _clickOutFlyoutHandler);
    };
    /**
   * Activates flyout menu considering screen orientation
   *
   * @param {JQuery} menu - Flout parent menu item
   */ var showFlyoutMenu = function showFlyoutMenu(menu) {
        isFlyoutHidden = false;
        if (!isWideScreen) {
            $header.addClass("header--mobile-flyout");
            $flyoutMenu.addClass("show");
            menu.addClass("active");
            $burgerBtn.addClass("open");
            return;
        }
        if (!$flyoutMenu.hasClass("show")) {
            $header.addClass("header--opened-flyout");
            $flyoutMenu.addClass("show");
            (0, $c4e6c829d2f8aa8a$var$_jquery["default"])("body").on("click", _clickOutFlyoutHandler);
        }
        // Do not complete operations if the same menu is opened
        if (menu.hasClass("active")) return;
        menu.siblings(".active").removeClass("active");
        menu.addClass("active");
    };
    /**
   * Dispatch flyout behaviour
   * when click event of the main navigation is fired
   *
   * @param {Event} e
   */ var flyoutEventHandler = function flyoutEventHandler(e) {
        var dataMenu = (0, $c4e6c829d2f8aa8a$var$_jquery["default"])(e.target).data("menu");
        if (!dataMenu) dataMenu = (0, $c4e6c829d2f8aa8a$var$_jquery["default"])(e.target).parent().data("menu");
        // If no data-menu dataset, perform default action
        if (!dataMenu) return;
        // Close flyout in case of attempt to activate the same link
        if (e.type === "click" && (0, $c4e6c829d2f8aa8a$var$_jquery["default"])(this).hasClass("active") && $flyoutMenu.hasClass("show")) {
            (0, $c4e6c829d2f8aa8a$var$_jquery["default"])(this).removeAttr("style").removeClass("active");
            closeFlyoutMenu(false);
            return;
        }
        // Activate a new item in main navigation
        (0, $c4e6c829d2f8aa8a$var$_jquery["default"])(this).siblings(".active").removeClass("active");
        (0, $c4e6c829d2f8aa8a$var$_jquery["default"])(this).addClass("active");
        // Activate needed flyout group
        var menu = $flyoutMenu.find('[data-category="' + dataMenu + '"]');
        if (!menu.length) return;
        e.preventDefault();
        // Show flyout with category
        if (menu.length) showFlyoutMenu(menu, !isWideScreen);
    };
    // Resize event handler
    (0, $c4e6c829d2f8aa8a$var$_jquery["default"])(window).on("resize", function(e) {
        var oldIsWideScreen = isWideScreen;
        isWideScreen = window.innerWidth > 991;
        if (oldIsWideScreen !== isWideScreen) {
            // console.log("isWideScreen", isWideScreen, oldIsWideScreen);
            $burgerBtn.removeClass("active").removeClass("open");
            $mainNav.find("li").removeClass("active");
            $mainNav.removeClass("show");
            $c4e6c829d2f8aa8a$var$donateSequence("fixed");
            $header.removeClass("header--mini");
            body.classList.remove("mini");
            $header.removeClass("header--mobile-flyout");
            $header.removeClass("header--opened-flyout");
            $header.removeClass("open-flyout");
            $flyoutMenu.removeClass("show");
            $flyoutMenu.find(".flyout-menu__category.active").removeClass("active");
            isFlyoutHidden = true;
            closeFlyoutMenu(true);
            scrollHandler();
        }
    });
    var mouseTimer;
    var currentElement;
    // Attach Flyout event handlers
    $mainNav.find(".has-category").on("mouseenter", function(e) {
        if (window.innerWidth <= 991) return;
        clearTimeout(mouseTimer); // Clear any existing timer
        if (currentElement !== e.currentTarget) currentElement = e.currentTarget;
        // Set a new timer
        mouseTimer = setTimeout(function() {
            // If the cursor is still on the same element after 500ms, do something
            if (currentElement === e.currentTarget) flyoutEventHandler(e);
        }, 500);
    });
    $mainNav.find(".has-category").on("mouseleave", function(e) {
        if (window.innerWidth <= 991) return;
        clearTimeout(mouseTimer); // Clear any existing timer
    });
    $mainNav.find("li:not(.has-category)").on("mouseenter", function(e) {
        if (window.innerWidth <= 991) return;
        clearTimeout(mouseTimer); // Clear any existing timer
        if (currentElement !== e.currentTarget) currentElement = e.currentTarget;
        // Set a new timer
        mouseTimer = setTimeout(function() {
            // If the cursor is still on the same element after 500ms, do something
            if (currentElement === e.currentTarget) {
                $mainNav.find(".has-category.active").removeClass("active");
                $burgerBtn.removeClass("active").removeClass("open");
                closeFlyoutMenu(true);
                (0, $c4e6c829d2f8aa8a$var$_jquery["default"])("body").off("click", _clickOutFlyoutHandler);
            }
        }, 500);
    });
    (0, $c4e6c829d2f8aa8a$var$_jquery["default"])(".flyout-menu").on("mouseleave", function() {
        if (window.innerWidth <= 991) return;
        $mainNav.find(".has-category.active").removeClass("active");
        $burgerBtn.removeClass("active").removeClass("open");
        closeFlyoutMenu(true);
        (0, $c4e6c829d2f8aa8a$var$_jquery["default"])("body").off("click", _clickOutFlyoutHandler);
    });
    $mainNav.find(".has-category").on("click", function(e) {
        if (window.innerWidth > 992) return;
        e.preventDefault();
        flyoutEventHandler(e);
    });
    $burgerBtn.on("click", function(e) {
        e.preventDefault();
        if ($mainNav.hasClass("show")) {
            if ($burgerBtn.hasClass("open")) {
                closeFlyoutMenu(false);
                $burgerBtn.removeClass("open");
                $header.removeClass("header--mobile-flyout");
                $flyoutMenu.find(".flyout-menu__category.active").removeClass("active");
            } else {
                if (window.innerWidth < 992) {
                    $header.removeClass("header--mini");
                    body.classList.remove("mini");
                    $c4e6c829d2f8aa8a$var$donateSequence("fixed");
                }
                $header.removeClass("open-flyout");
                $burgerBtn.removeClass("active");
                $mainNav.removeClass("show");
                $header.removeClass("header--mobile-flyout");
                $flyoutMenu.removeClass("show");
                $flyoutMenu.find(".flyout-menu__category.active").removeClass("active");
                isFlyoutHidden = true;
            }
        } else {
            $header.addClass("open-flyout");
            $burgerBtn.addClass("active");
            $mainNav.addClass("show");
            isFlyoutHidden = false;
            if (window.innerWidth < 992) {
                $header.addClass("header--mini");
                body.classList.add("mini");
                $c4e6c829d2f8aa8a$var$donateSequence("");
            }
        }
    });
    // Scroll
    var scrollHandler = function scrollHandler() {
        var sc = window.scrollY || window.pageYOffset;
        if (sc > scrollStart) {
            if (isHeaderMini) return;
            $header.addClass("header--mini");
            body.classList.add("mini");
            $c4e6c829d2f8aa8a$var$donateSequence("");
            isHeaderMini = true;
        } else {
            if ($header.hasClass("open-flyout")) return;
            if ($header.hasClass("header--mini")) {
                $header.removeClass("header--mini");
                body.classList.remove("mini");
                $c4e6c829d2f8aa8a$var$donateSequence("fixed");
                isHeaderMini = false;
            }
        }
    };
    (0, $c4e6c829d2f8aa8a$var$_jquery["default"])(window).on("scroll", scrollHandler);
    // On page load with offset
    if ((window.scrollY || window.pageYOffset) > headerHeight) {
        $header.addClass("header--mini");
        body.classList.add("mini");
        $c4e6c829d2f8aa8a$var$donateSequence("");
    } else {
        $header.removeClass("header--mini");
        body.classList.remove("mini");
        $c4e6c829d2f8aa8a$var$donateSequence("fixed");
    }
};

});


//# sourceMappingURL=flyoutMenu.module.f3a5eb1e.js.map
